import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

declare global {
  interface Window {
    ym: (id: number, action: string, target: string) => void;
  }
}

export const METRIKA_ID = 104713371;

/** Fire a Yandex Metrika goal (reachGoal). No-op if Metrika is not loaded. */
export function reachGoal(goal: string) {
  if (typeof window !== 'undefined' && typeof window.ym === 'function') {
    window.ym(METRIKA_ID, 'reachGoal', goal);
  }
}

export function YandexMetrika() {
  const location = useLocation();
  useEffect(() => {
    if (typeof window.ym === 'function') {
      window.ym(METRIKA_ID, 'hit', window.location.href);
    }
  }, [location.pathname]);
  return null;
}
